import { clsx } from 'clsx';

export function classifyMargin(value) {
  if (value == null) return 'mid';
  if (value > 0.3) return 'good';
  if (value < 0.2) return 'bad';
  return 'mid';
}

const CLASSES = {
  good: 'bg-margin-good text-margin-goodText font-bold rounded-xs px-2 py-0.5',
  mid: 'text-text-dark font-semibold px-2 py-0.5',
  bad: 'bg-margin-bad text-margin-badText font-bold rounded-xs px-2 py-0.5',
};

export function MarginPill({ value, className }) {
  const tone = classifyMargin(value);
  const formatted = value == null ? '-' : `${(value * 100).toFixed(2)}%`;
  return <span className={clsx('inline-block tabular-nums text-[11.5px]', CLASSES[tone], className)}>{formatted}</span>;
}
